{
  "title": "Configurações",
  "tabs": {
    "provider": "Provedor",
    "connection": "Conexão",
    "appearance": "Aparência",
    "agent": "Agente",
    "features": "Recursos",
    "mcp": "MCP"
  },
  "appearance": {
    "themeHeading": "Tema",
    "themeLight": "Claro",
    "themeDark": "Escuro",
    "themeSystem": "Sistema",
    "themeSystemHint": "Sistema segue a preferência claro/escuro do seu sistema operacional.",
    "preferencesHeading": "Preferências",
    "compactDensity": "Densidade compacta",
    "compactDensityHint": "Espaçamento mais estreito em todo o chat.",
    "soundOnComplete": "Som ao concluir",
    "soundOnCompleteHint": "Reproduz um toque suave quando uma execução termina.",
    "titleAnimation": "Animação do título",
    "titleAnimationHint": "Mostrar título animado do terminal no CLI.",
    "languageHeading": "Idioma",
    "languageLabel": "Idioma da interface",
    "languageHint": "Altera apenas o texto da interface. Prompts, skills e a saída do modelo não são afetados."
  },
  "model": {
    "heading": "Modelo",
    "loading": "Carregando modelos...",
    "notFound": "Nenhum modelo encontrado para este provedor. O catálogo pode estar vazio ou ainda carregando.",
    "selectProviderFirst": "Selecione um provedor primeiro",
    "context": "{{count}}k contexto"
  },
  "connection": {
    "wsUrlLabel": "URL do servidor WebSocket",
    "wsUrlPlaceholder": "ws://localhost:3457",
    "wsUrlHint": "URL do servidor WebSocket do agente. O servidor é executado junto com o CLI.",
    "startingHeading": "Iniciando o servidor WebSocket",
    "startingBody": "Autônomo: execute ./dev.ps1 da raiz do repo, ou defina WS_HOST/WS_PORT antes de iniciar wstackui. Ou junto à CLI: wstack --webui."
  },
  "provider": {
    "subscriptionHeading": "Login com assinatura",
    "apiKeysHeading": "Provedores de chave de API",
    "apiKeysBody": "Escolha um provedor do catálogo e adicione uma chave de API, ou gerencie os provedores salvos.",
    "tabCatalog": "Catálogo",
    "tabSaved": "Salvos ({{count}})",
    "searchPlaceholder": "Pesquisar entre {{count}} provedores (nome / id / família)…",
    "loadingCatalog": "Carregando catálogo...",
    "noMatch": "Nenhum provedor corresponde a \"{{query}}\".",
    "configured": "Configurado",
    "reachable": "Acessível",
    "envVar": "ENV: {{var}}",
    "modelCount_one": "{{count}} modelo",
    "modelCount_other": "{{count}} modelos",
    "keyPlaceholder": "Chave de API do {{name}}",
    "orEnv": "Ou defina {{env}} no ambiente.",
    "addApiKey": "Adicionar chave de API",
    "manageKeys": "Gerencie suas chaves de API e configurações de provedor",
    "addProvider": "Adicionar provedor",
    "addCustomHeading": "Adicionar provedor personalizado",
    "localServers": "Servidores locais — clique para preencher:",
    "providerIdPlaceholder": "ID do provedor (ex. my-llm-server)",
    "apiKeyOptionalPlaceholder": "Chave de API (opcional)",
    "noSaved": "Nenhum provedor salvo",
    "noSavedHint": "Adicione um provedor para começar",
    "apiKeysLabel": "Chaves de API",
    "addKey": "Adicionar chave",
    "noKeys": "Nenhuma chave configurada",
    "active": "Ativa",
    "setActive": "Definir como ativa",
    "keyLabelPlaceholder": "Rótulo da chave (ex. default, production)",
    "apiKeyPlaceholder": "Chave de API",
    "saveKey": "Salvar chave",
    "savedToast": "Chave salva para {{name}}"
  },
  "mcp": {
    "status": {
      "connected": "Conectado",
      "connecting": "Conectando",
      "sleeping": "Inativo",
      "discovering": "Descobrindo",
      "error": "Erro",
      "stopped": "Parado",
      "unknown": "Desconhecido"
    },
    "disabled": "Os servidores MCP estão desativados.",
    "wakeTitle": "Acordar servidor",
    "sleepTitle": "Colocar em repouso",
    "discoverTitle": "Descobrir ferramentas",
    "editTitle": "Editar",
    "removeTitle": "Remover",
    "statusLabel": "Status:",
    "enabledLabel": "Ativado:",
    "yes": "Sim",
    "no": "Não",
    "descriptionLabel": "Descrição:",
    "pidLabel": "PID:",
    "errorLabel": "Erro:",
    "toolsLabel": "Ferramentas ({{count}}):",
    "noTools": "Nenhuma ferramenta descoberta ainda",
    "serverNameRequired": "O nome do servidor é obrigatório",
    "dialogTitleEdit": "Editar servidor MCP",
    "dialogTitleAdd": "Adicionar servidor MCP",
    "dialogTitleAddCustom": "Adicionar servidor MCP personalizado",
    "fieldName": "Nome",
    "fieldNamePlaceholder": "ex. github, filesystem",
    "fieldTransport": "Transporte",
    "fieldUrl": "URL",
    "fieldCommand": "Comando",
    "fieldCommandPlaceholder": "ex. npx",
    "fieldArgs": "Args",
    "fieldArgsHint": "(separados por espaços)",
    "fieldArgsPlaceholder": "ex. -y @modelcontextprotocol/server-github",
    "fieldEnv": "Variáveis de ambiente",
    "fieldEnvHint": "(KEY=valor, uma por linha)",
    "fieldDescription": "Descrição",
    "fieldDescriptionPlaceholder": "Servidor MCP do GitHub para acesso ao repositório",
    "enableServer": "Ativar servidor",
    "lazyConnect": "Conexão preguiçosa",
    "lazyConnectHint": "(não inicia até a primeira chamada; hiberna quando ocioso)",
    "saveChanges": "Salvar alterações",
    "addServer": "Adicionar servidor",
    "requires": "Requer: {{vars}}",
    "added": "Adicionado",
    "heading": "Servidores MCP",
    "summary": "{{connected}} conectados · {{sleeping}} inativos · {{total}} no total",
    "addCustom": "Personalizado",
    "tabRecommended": "Recomendados",
    "tabServers": "Servidores",
    "tabAddCustom": "Personalizado",
    "recommendedBody": "Adição com um clique para servidores MCP populares. Clique em Adicionar para preencher a configuração e depois confirme. Servidores que exigem credenciais precisarão de suas variáveis de ambiente antes do uso.",
    "loadingServers": "Carregando servidores...",
    "noServers": "Nenhum servidor MCP configurado",
    "noServersHint": "Mude para a aba Recomendados para adicionar servidores populares, ou Personalizado para os seus.",
    "addCustomBody": "Configure um servidor MCP personalizado com transporte stdio, SSE ou HTTP.",
    "addCustomBodyHint": "Para servidores populares, use a aba Recomendados — tudo já está pré-configurado.",
    "removeConfirmTitle": "Remover o servidor \"{{name}}\"?",
    "removeConfirmBody": "Isso remove o servidor MCP da sua configuração.",
    "toastAdded": "Servidor \"{{name}}\" adicionado",
    "toastRemoved": "Servidor \"{{name}}\" removido",
    "toastDiscovered": "Descobertas {{count}} ferramentas de \"{{name}}\"",
    "toastSleeping": "O servidor \"{{name}}\" está inativo",
    "toastConnected": "Servidor \"{{name}}\" conectado",
    "toastReconnected": "Servidor \"{{name}}\" reconectado",
    "toastDisconnected": "Servidor \"{{name}}\" desconectado: {{reason}}",
    "toastError": "Servidor \"{{name}}\" erro: {{error}}",
    "disabledHint": "Ative o sinalizador \"Servidores MCP\" na aba Recursos para usar esta seção."
  },
  "allowlist": {
    "title": "Limpar a allowlist salva?",
    "body_one": "Isso removerá o modelo fixado para {{provider}}. O seletor de modelos voltará ao catálogo models.dev.",
    "body_other": "Isso removerá os {{count}} modelos fixados para {{provider}}. O seletor de modelos voltará ao catálogo models.dev.",
    "undoHint": "Você pode desfazer por 8 segundos após confirmar.",
    "keepTitle": "Manter allowlist (Esc)",
    "clearTitle": "Limpar allowlist (Enter)",
    "clear": "Limpar allowlist"
  },
  "oauth": {
    "termsWarning": "Entre com uma assinatura em vez de uma chave de API. Usar uma assinatura fora de seu cliente oficial pode violar os Termos do provedor — sua conta pode ser limitada ou banida. Uma chave de API é o caminho sancionado para uso programático.",
    "signIn": "Entrar",
    "waitingBrowser": "Aguardando seu login…",
    "openSignIn": "Abrir página de login",
    "pasteLoopbackBusy": "Porta loopback ocupada — cole a URL de redirecionamento",
    "pasteCantReach": "O navegador não alcança este servidor? Cole a URL de redirecionamento",
    "submit": "Enviar",
    "enterCode": "Insira este código na página de verificação:",
    "openVerification": "Abrir página de verificação",
    "waitingCode": "Aguardando autorização…",
    "exchanging": "Trocando tokens…",
    "fetchingModels": "Buscando modelos…",
    "signedIn": "Conectado.",
    "signedInToast": "Conectado — {{provider}}",
    "signInFailed": "Login falhou"
  },
  "agent": {
    "modelHeading": "Modelo",
    "autonomyHeading": "Autonomia e Comportamento",
    "autonomyModeLabel": "Modo de autonomia",
    "autonomyModeHint": "Quão independentemente o agente prossegue entre turnos.",
    "autonomyModeOff": "Desativado — controle manual total",
    "autonomyModeSuggest": "Sugerir — sugere os próximos passos",
    "autonomyModeAuto": "Auto — breve atraso de confirmação",
    "autonomyModeEternal": "Eterno — autônomo até o objetivo concluído",
    "autonomyModeEternalParallel": "Eterno Paralelo — frota multi-agente",
    "autoProceedDelayLabel": "Atraso de auto-prosseguir",
    "autoProceedDelayHint": "Milissegundos antes de o agente auto-prosseguir no modo Auto. 0 = imediato.",
    "yoloLabel": "Modo YOLO",
    "yoloHint": "Ignorar os prompts de confirmação de ferramentas — o agente roda sem perguntar.",
    "refineHeading": "Refinamento de Prompt",
    "enableRefineLabel": "Ativar refinamento",
    "enableRefineHint": "Reescreve os prompts antes de enviar — instruções mais claras, melhores resultados.",
    "refineDelayLabel": "Atraso de refinamento",
    "refineDelayHint": "Contagem regressiva antes do envio automático do prompt refinado.",
    "refineLanguageLabel": "Idioma de refinamento",
    "refineLanguageHint": "Mantenha seu idioma ou traduza para inglês para o modelo.",
    "refineLanguageOriginal": "Original — mantenha seu idioma",
    "refineLanguageEnglish": "Inglês — traduzir para inglês",
    "reasoningHeading": "Raciocínio e Cache",
    "reasoningModeLabel": "Modo de raciocínio",
    "reasoningModeHint": "Controla como o modelo usa o pensamento estendido. Auto = padrão do provedor.",
    "reasoningModeAuto": "Auto — padrão do provedor",
    "reasoningModeOn": "Ligado — forçar pensamento",
    "reasoningModeOff": "Desligado — desativar pensamento",
    "reasoningEffortLabel": "Esforço de raciocínio",
    "reasoningEffortHint": "Quanto compute o modelo gasta pensando. Enviado apenas quando o modelo suporta.",
    "reasoningEffortNone": "Nenhum",
    "reasoningEffortMinimal": "Mínimo",
    "reasoningEffortLow": "Baixo",
    "reasoningEffortMedium": "Médio",
    "reasoningEffortHigh": "Alto",
    "reasoningEffortXhigh": "Muito alto",
    "reasoningEffortMax": "Máx",
    "preserveThinkingLabel": "Preservar pensamento",
    "preserveThinkingHint": "Mantém os blocos de raciocínio entre turnos para continuidade de contexto.",
    "cacheTtlLabel": "TTL de cache",
    "cacheTtlHint": "Tempo de vida do cache de prompt. 1h custa mais na escrita mas economiza em releituras (Anthropic).",
    "cacheTtlDefault": "Padrão — padrão do provedor",
    "cacheTtl5m": "5 minutos",
    "cacheTtl1h": "1 hora",
    "capsHint": "Use wstack models caps para verificar o que o modelo atual suporta. Configurações não suportadas são omitidas silenciosamente por requisição.",
    "fallbackHeading": "Fallbacks de modelo",
    "fallbackBody": "Quando o modelo ativo é rate-limitado (429/529), dá erro 5xx ou trava — após suas próprias retentativas — o agente rotaciona para o próximo modelo desta cadeia. Também usado como padrão para os sub-agentes workers do SDD.",
    "autoFallbackLabel": "Fallback automático",
    "autoFallbackHint": "Quando a cadeia acima está vazia, derive uma automaticamente de seus provedores com chave.",
    "favoritesOnlyLabel": "Apenas favoritos",
    "favoritesOnlyHint": "Quando o fallback automático deriva uma cadeia, restrinja-a aos seus modelos favoritos.",
    "profilesHeading": "Perfis de fallback",
    "addProfile": "Adicionar",
    "noProfiles": "Ainda não há perfis de fallback nomeados.",
    "createDefault": "Criar padrão a partir do modelo ativo",
    "useChain": "Usar cadeia",
    "setLeader": "Definir líder",
    "profileEmpty": "O perfil está vazio.",
    "favoritesHeading": "Modelos favoritos",
    "favoritesEmpty": "Os favoritos são mostrados primeiro e podem restringir o fallback automático.",
    "routingHeading": "Roteamento de modelo",
    "routingRouteKey": "Chave de rota de modelo",
    "routingPhasesGroup": "Fases",
    "routingRolesGroup": "Funções {{label}}",
    "routingCustomGroup": "Rotas personalizadas existentes",
    "routingTargetPlaceholder": "fallback1, provider/model, ou vazio",
    "routingSet": "Definir",
    "routingReasoningModeAria": "Modo raciocínio nova rota",
    "routingReasoningEffortAria": "Esforço raciocínio nova rota",
    "routingReasoningPreserveAria": "Preservação raciocínio nova rota",
    "routingReasoningModeFor": "Modo raciocínio para {{key}}",
    "routingReasoningEffortFor": "Esforço raciocínio para {{key}}",
    "routingReasoningPreserveFor": "Preservação raciocínio para {{key}}",
    "noRoutes": "Ainda não há rotas de modelo.",
    "leaderModel": "modelo líder",
    "hqHeading": "Cliente HQ",
    "hqPublishingLabel": "Publicação HQ",
    "hqPublishingHint": "Publica esta sessão WebUI/cliente no WrongStack HQ. Clientes da mesma máquina podem auto-descobrir a auth HQ local; clientes remotos usam a URL/token abaixo.",
    "hqUrlLabel": "URL HQ",
    "hqUrlHint": "Deixe vazio para auto-descoberta na mesma máquina.",
    "hqTokenLabel": "Token do cliente HQ",
    "executionHeading": "Execução",
    "maxIterationsLabel": "Iterações máx por run",
    "maxIterationsHint": "Teto rígido de turnos LLM por agent.run().",
    "autoProceedMaxIterationsLabel": "Iterações máx de auto-prosseguir",
    "autoProceedMaxIterationsHint": "Para o auto-prosseguir após N iterações. 0 = ilimitado.",
    "confirmExitLabel": "Confirmar antes de sair",
    "confirmExitHint": "Primeiro Ctrl+C aborta o trabalho, segundo confirma a saída.",
    "chimeLabel": "Som ao concluir",
    "chimeHint": "Campainha do terminal quando um run de agente termina.",
    "fleetHeading": "Frota e Streaming",
    "streamFleetLabel": "Transmitir eventos da frota",
    "streamFleetHint": "Mostra a atividade ao vivo dos sub-agentes no painel da frota.",
    "maxConcurrentLabel": "Sub-agentes concorrentes máx",
    "maxConcurrentHint": "Número máximo de sub-agentes que podem rodar simultaneamente.",
    "nextPredictionLabel": "Previsão do próximo passo",
    "nextPredictionHint": "Após um turno, prevê os prováveis próximos passos.",
    "telegramHeading": "Notificações do Telegram",
    "telegramSessionEndLabel": "Fim de sessão",
    "telegramSessionEndHint": "Envia um resumo quando uma sessão termina.",
    "telegramDelegateLabel": "Delegado concluído",
    "telegramDelegateHint": "Envia uma nota humanizada quando um sub-agente conclui.",
    "telegramLongToolLabel": "Ferramentas longas",
    "telegramLongToolHint": "Notifica quando uma ferramenta excede {{ms}}ms. 0 para desativar.",
    "telegramChangesApply": "As mudanças se aplicam imediatamente.",
    "telegramNotConfigured": "O Telegram não está configurado. Execute /telegram-setup na CLI para conectar um bot primeiro.",
    "addModelToProfile": "Adicionar modelo ao perfil…",
    "addFavoriteModel": "Adicionar modelo favorito…",
    "hqRawContentLabel": "Conteúdo HQ bruto",
    "hqRawContentHint": "Enviar pré-visualizações de conteúdo brutas para HQ em vez de pré-visualizações redigidas."
  },
  "features": {
    "flagsHeading": "Sinalizadores de Recursos",
    "mcpLabel": "Servidores MCP",
    "mcpHint": "Habilita integrações Model Context Protocol.",
    "pluginsLabel": "Plugins",
    "pluginsHint": "Carrega e executa plugins instalados pelo usuário.",
    "memoryLabel": "Memória",
    "memoryHint": "Persiste e recupera fatos entre sessões.",
    "skillsLabel": "Habilidades",
    "skillsHint": "Carrega prompts de habilidades específicas do domínio.",
    "modelsRegistryLabel": "Registro de modelos",
    "modelsRegistryHint": "Usa o catálogo models.dev para descoberta de provedores.",
    "indexOnStartLabel": "Indexar ao iniciar",
    "indexOnStartHint": "Constrói o índice de símbolos do código ao iniciar a sessão.",
    "contextHeading": "Contexto e Depuração",
    "autoCompactLabel": "Auto-compactar contexto",
    "autoCompactHint": "Apara automaticamente a janela de contexto perto dos limites.",
    "compactorStrategyLabel": "Estratégia de compactação",
    "compactorStrategyHint": "Como o contexto é compactado quando cresce demais.",
    "compactorStrategyHybrid": "Híbrida — regras rápidas (padrão)",
    "compactorStrategyIntelligent": "Inteligente — resumo LLM",
    "compactorStrategySelective": "Seletiva — seleção guiada por LLM",
    "contextModeLabel": "Modo de contexto",
    "contextModeHint": "Política de janela de contexto — equilibrado é o padrão.",
    "contextModeBalanced": "Equilibrado — uso normal do contexto",
    "contextModeFrugal": "Frugal — uso conservador de tokens",
    "contextModeDeep": "Profundo — contexto maior para tarefas complexas",
    "contextModeArchival": "Arquivo — maximiza a retenção de contexto",
    "tokenSavingLabel": "Modo de economia de tokens",
    "tokenSavingHint": "Quão agressivamente reduzir o uso de tokens.",
    "tokenSavingOff": "Desativado — sem economia",
    "tokenSavingMinimal": "Mínimo — otimização básica",
    "tokenSavingLight": "Leve — redução moderada",
    "tokenSavingMedium": "Médio — economias significativas",
    "tokenSavingAggressive": "Agressivo — compressão máxima",
    "logLevelLabel": "Nível de log",
    "logLevelHint": "Severidade mínima para logging do lado servidor.",
    "logLevelDebug": "Debug — tudo",
    "logLevelInfo": "Info — fluxo normal",
    "logLevelWarn": "Warn — apenas problemas",
    "logLevelError": "Error — apenas falhas",
    "auditLevelLabel": "Nível de auditoria",
    "auditLevelHint": "Nível de detalhe para logs de auditoria de sessão.",
    "auditLevelMinimal": "Mínimo — apenas erros",
    "auditLevelStandard": "Padrão — chamadas de ferramentas + erros",
    "auditLevelFull": "Completo — cada evento (logs grandes)"
  },
  "toast": {
    "switchingTo": "Mudando para {{provider}} / {{model}}…",
    "fallbackExists": "O perfil de fallback \"{{name}}\" já existe",
    "selectProviderModelFirst": "Selecione um provedor e um modelo primeiro",
    "defaultProfileCreated": "Perfil de fallback padrão criado",
    "profileEmpty": "O perfil de fallback \"{{name}}\" está vazio",
    "leaderSetFrom": "Líder definido a partir de {{name}}"
  }
}
